<template>
  <v-layout row justify-space-between ma-2>
    <div>
      <v-btn color="primary" @click="newPosition">
        Hinzufügen
      </v-btn>
      <v-btn
        :disabled="!validateable || loading"
        @click="validate"
        :loading="loading"
        color="success"
        class="ml-2"
      >
        Validieren
      </v-btn>
    </div>

    <div>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="sort"
          >
            <v-icon>sort</v-icon>
          </v-btn>
        </template>
        <span>Sortieren</span>
      </v-tooltip>
      <!--
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile @click="">
            <v-list-tile-title>Exportieren</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="">
            <v-list-tile-title>Drucken</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      -->
    </div>
  </v-layout>
</template>

<script>

export default {
  props: {
    validateable: Boolean,
    loading: Boolean
  },

  data() {
    return {
      editedPosition: {
        date: new Date().toISOString().substr(0, 10),
        code: "",
        ref_code: "",
        session: 1,
        quantity: 1
      },
    }
  },

  methods: {
    newPosition() {
      this.$emit("new-position")
    },

    validate() {
      this.$emit("validate")
    },

    sort() {
      this.$emit("sort")
    }
  }
}
</script>

<style scoped>
</style>

